import { WEEKDAY_LABEL, formatPhoneBR, normalizePhoneBR } from "@farmacias/schema";
const SCHEMA_DAY = {
    seg: "Monday",
    ter: "Tuesday",
    qua: "Wednesday",
    qui: "Thursday",
    sex: "Friday",
    sab: "Saturday",
    dom: "Sunday",
};
/** JSON-LD `schema.org/Pharmacy` — sem `<script>` em volta (o render adiciona). */
export function buildPharmacyJsonLd(f, baseUrl) {
    const phone = normalizePhoneBR(f.telefoneComercial) ?? normalizePhoneBR(f.whatsapp);
    const e = f.endereco;
    const openingHours = f.horarios
        .filter((h) => SCHEMA_DAY[h.dia])
        .map((h) => ({
        "@type": "OpeningHoursSpecification",
        dayOfWeek: `https://schema.org/${SCHEMA_DAY[h.dia]}`,
        opens: h.abre,
        closes: h.fecha,
    }));
    const data = {
        "@context": "https://schema.org",
        "@type": "Pharmacy",
        name: f.nomeFantasia || f.razaoSocial,
        legalName: f.razaoSocial || undefined,
        url: baseUrl,
        telephone: phone ? `+${phone}` : undefined,
        email: f.email || undefined,
        image: f.logo?.url || undefined,
        address: {
            "@type": "PostalAddress",
            streetAddress: [e.logradouro, e.numero].filter(Boolean).join(", ") || undefined,
            addressLocality: e.cidade || undefined,
            addressRegion: e.uf || undefined,
            postalCode: e.cep || undefined,
            addressCountry: "BR",
        },
        openingHoursSpecification: openingHours.length ? openingHours : undefined,
    };
    return JSON.stringify(data, (_k, v) => (v === undefined ? undefined : v));
}
export { WEEKDAY_LABEL, formatPhoneBR };
//# sourceMappingURL=jsonld.js.map